module.exports = __webpack_public_path__ + "static/media/banner.25f9b435.jpg";